import React from 'react';
import LegalLayout from '../containers/Legal/LegalLayout';

const Privacy = () => (
  <LegalLayout title="Privacy Policy" updated="June 26, 2026">
    <p className="legal-intro">
      <strong>J &amp; G Detailing LLC</strong> ("we," "us," or "our") respects your privacy. This
      Privacy Policy explains what information we collect, how we use it, and the choices you have
      when you use our website or book our services.
    </p>

    <h2>1. Information We Collect</h2>
    <p>When you book an appointment or contact us, we may collect:</p>
    <ul>
      <li><strong>Contact details</strong> — your name, phone number, and email address.</li>
      <li><strong>Booking details</strong> — the service requested, vehicle type, date, time, and location.</li>
      <li><strong>Communications</strong> — messages you send us and our replies.</li>
    </ul>
    <p>We do not collect or store payment card details through this website.</p>

    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>To schedule, confirm, and manage your appointments.</li>
      <li>To contact you about your booking by phone, text message, or email.</li>
      <li>To respond to your questions and provide customer service.</li>
      <li>To improve our services and operate our business.</li>
    </ul>

    <h2>3. Text Messages (SMS)</h2>
    <p>
      If you opt in, we use a third-party messaging provider (Twilio) to send booking-related text
      messages such as confirmations and reminders. Message and data rates may apply. You can opt
      out at any time by replying <strong>STOP</strong>. Your consent to receive texts is not a
      condition of purchasing any service.
    </p>

    <h2>4. How We Share Information</h2>
    <p>We do not sell your personal information. We share it only as needed to operate our business:</p>
    <ul>
      <li><strong>Service providers</strong> — trusted vendors who help us run our booking and communications (for example, Twilio for SMS and our email/form provider for notifications).</li>
      <li><strong>Legal reasons</strong> — when required by law or to protect our rights, safety, or property.</li>
    </ul>

    <h2>5. Cookies &amp; Analytics</h2>
    <p>
      Our website may use basic cookies or similar technologies to function properly and understand
      general usage. You can control cookies through your browser settings; disabling them may affect
      some features.
    </p>

    <h2>6. Data Retention</h2>
    <p>
      We keep your information for as long as needed to provide our services and for legitimate
      business or legal purposes. When it is no longer needed, we take reasonable steps to delete or
      anonymize it.
    </p>

    <h2>7. Data Security</h2>
    <p>
      We use reasonable administrative and technical measures to protect your information. However,
      no method of transmission or storage is completely secure, and we cannot guarantee absolute security.
    </p>

    <h2>8. Your Choices &amp; Rights</h2>
    <ul>
      <li>You may request access to, correction of, or deletion of your personal information.</li>
      <li>You may opt out of marketing or text messages at any time.</li>
      <li>To make a request, contact us using the details below.</li>
    </ul>

    <h2>9. Children's Privacy</h2>
    <p>
      Our services are not directed to children under 13, and we do not knowingly collect personal
      information from them.
    </p>

    <h2>10. Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Changes are effective when posted to this
      page, with the "Last updated" date revised accordingly.
    </p>

    <h2>11. Contact Us</h2>
    <p>
      For privacy questions or requests, contact us at{' '}
      <a href="mailto:contact@jgdetailingllc.com">contact@jgdetailingllc.com</a> or call (763) 710-9136.
      <br />J &amp; G Detailing LLC · 701 Decatur Ave N, Suite 204, Golden Valley, MN 55427.
    </p>

    <p className="legal-note">
      This page is provided as a general template and does not constitute legal advice. We recommend
      having it reviewed by a qualified attorney to ensure it fits your business and complies with
      applicable laws (such as state privacy and SMS/TCPA requirements).
    </p>
  </LegalLayout>
);

export default Privacy;
